import {ICookieBanner} from "@/shared/CookieBanner/interfaces/cookie-banner.interface";
import ConfirmAction = ICookieBanner.ConfirmAction;
import {bus} from "@/plugins/bus";

// Декларация глобальных типов
declare global {
  interface Window {
    dataLayer?: any[];
  }
}

export class CookieBannerHelper {
  data = {
    gtmLoaded: false,
  };
  cookieConfig: ICookieBanner.ICookieConfig = {
    necessary: true,
    optional: false,
    gtm: false,
  };

  updateConfigObj(storageInfo: ICookieBanner.IStorageInfo) {
    this.cookieConfig = { ...storageInfo.config };
    this.changeConfigAction(storageInfo);
  }

  updateConfigProp(name: string, value: boolean) {
    this.cookieConfig[name] = value;
    let storageInfo: ICookieBanner.IStorageInfo = null;
    let storageInfoStr = localStorage.getItem(ICookieBanner.LocalStorageKeys.CookieBanner);

    if (storageInfoStr) {
      storageInfo = JSON.parse(storageInfoStr);
      storageInfo.config = {...this.cookieConfig};
    }
    else {
      storageInfo = {
        action: ConfirmAction.Ignore,
        config: {...this.cookieConfig},
      };
    }
    this.changeConfigAction(storageInfo);
  }

  changeConfigAction(storageInfo: ICookieBanner.IStorageInfo) {
    localStorage.setItem(ICookieBanner.LocalStorageKeys.CookieBanner, JSON.stringify(storageInfo));

    if (this.cookieConfig.gtm) this.initGTM();
    else this.removeGTM();

    bus.$emit(ICookieBanner.Event.ChangeCookieValue);
  }

  checkScriptsAccess() {
    let storageInfoStr = localStorage.getItem(ICookieBanner.LocalStorageKeys.CookieBanner);
    if (storageInfoStr) {
      let storageInfo: ICookieBanner.IStorageInfo = JSON.parse(storageInfoStr);
      this.cookieConfig = {...storageInfo.config};
      if ([ICookieBanner.ConfirmAction.ConfirmSelected, ICookieBanner.ConfirmAction.ConfirmAll].includes(storageInfo.action)) {
        if (storageInfo.config.gtm) {
          this.initGTM();
        }
      }
    }
  }

  initGTM() {
    if (this.data.gtmLoaded || process.env.VUE_APP_LOC === 'loc') return;

    const gtmId = process.env.VUE_APP_GTM_ID || 'GTM-XXXXXXX';

    // Проверяем, не загружен ли уже GTM
    if (document.getElementById('gtm-script')) {
      this.data.gtmLoaded = true
      return
    }

    // Создаем и загружаем GTM скрипт
    const script = document.createElement('script')
    script.id = 'gtm-script'
    script.innerHTML = `
      (function(w,d,s,l,i){
        w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),
        dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `
    document.head.appendChild(script)

    // Добавляем noscript iframe
    this.addGTMIframe(gtmId);

    this.data.gtmLoaded = true;

    // Отправляем событие о согласии
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'cookie_consent_given',
        consent_category: 'gtm'
      })
    }
  }

  addGTMIframe(gtmId: string) {
    // Проверяем, есть ли уже iframe
    if (document.querySelector('iframe[src*="googletagmanager"]')) {
      return
    }

    const noscript = document.createElement('noscript')
    const iframe = document.createElement('iframe')
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`
    iframe.height = '0'
    iframe.width = '0'
    iframe.style.display = 'none'
    iframe.style.visibility = 'hidden'
    noscript.appendChild(iframe)

    document.body.insertBefore(noscript, document.body.firstChild)
  }

  removeGTM() {
    const gtmScript = document.getElementById('gtm-script');
    if (gtmScript) {
      gtmScript.remove();
    }

    // Удаляем iframe
    const iframes = document.querySelectorAll('iframe[src*="googletagmanager"]')
    iframes.forEach(iframe => {
      const noscript = iframe.closest('noscript')
      if (noscript) {
        noscript.remove()
      }
    })

    // Очищаем dataLayer, но сохраняем историю
    if (window.dataLayer) {
      window.dataLayer = [];
    }

    this.data.gtmLoaded = false;
  }
}

export const cookieBannerHelper: CookieBannerHelper = new CookieBannerHelper();